import { render, staticRenderFns } from "./Agence.vue?vue&type=template&id=12cb98e1&scoped=true"
import script from "./Agence.vue?vue&type=script&lang=js"
export * from "./Agence.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cb98e1",
  null
  
)

export default component.exports